// extracted by mini-css-extract-plugin
export default {"place":"styles_place__UtX3R","image":"styles_image__07HY4","text":"styles_text__ggRne"};